// Contexts
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useKycContextConsumerHook } from 'containers/kyc/contexts/kyc.context';
// Event Handlers
import { KycErrorHandlers } from '../handlers/kyc-error.handlers';
// Types
import { KycErrorMethodsHandlersType } from '../handlers/types/kyc-error.handlers.type';

const useKycErrorHook = (): KycErrorMethodsHandlersType => {
  const { setKycState } = useKycContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook();

  return KycErrorHandlers({ setError, setKycState });
};

export { useKycErrorHook };
